import React, { useState, useEffect } from 'react';
import '../Header.css';
import '../Buttons.css';
import axios from 'axios';
const VAPID_PUBLIC_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY;

const SUPHeader = ({ currentTab, handleTabChange, handleLogout, currentSupplier, setCurrentSupplier, isNewSupplierMode }) => {
    const [isMobile, setIsMobile] = useState(false);


    useEffect(() => {
        const mediaQuery = window.matchMedia('(max-width: 767px)');
        const updateMobile = (e) => setIsMobile(e.matches);

        setIsMobile(mediaQuery.matches);
        mediaQuery.addEventListener('change', updateMobile);

        return () => mediaQuery.removeEventListener('change', updateMobile);
    }, []);

    // All possible tabs
    const allTabs = [
        'Cashier',
        'Home',
        'Supplier',
        'Admin',
    ];

    // Role-based filtering
    let tabs = [];

    if (currentSupplier?.role === 'ADMIN') {
        // ADMIN sees everything
        tabs = allTabs;
    } else if (currentSupplier?.role === 'CASHIER') {
        // CASHIER sees only Cashier tab
        tabs = ['Cashier'];
    } else if (currentSupplier?.role === 'BUYER') {
        // BUYER sees only Home tab
        tabs = ['Home'];
    }

    return (
        <>
            <div className="header-wrapper">

                <div className="header">

                    <div className="header-title">
                        <img src="/icons/logo-192.png" alt="Grow Your Food logo" className="header-logo" />
                    </div>

                    <div className="header-scroll">
                        <div className="tabs">
                            {isMobile ? (
                                <select
                                    value={currentTab}
                                    onChange={(e) => handleTabChange(e.target.value)}
                                    className="tabs-dropdown"
                                >
                                    {tabs.map((tab) => (
                                        <option key={tab} value={tab}>
                                            {tab}
                                        </option>
                                    )
                                    )}

                                </select>
                            ) : (
                                tabs.map((tab) => (
                                    <div
                                        key={tab}
                                        className={`tab ${currentTab === tab ? 'active' : ''}`}
                                        onClick={() => handleTabChange(tab)}
                                    >
                                        {tab}
                                    </div>
                                ))
                            )}
                        </div>

                        <div className="header-buttons">
                            <button className="button" onClick={handleLogout}>Logout</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SUPHeader;
